import { render, staticRenderFns } from "./travel-insurance-companies.html?vue&type=template&id=ef2c4578&scoped=true&"
import script from "./travel-insurance-companies.js?vue&type=script&lang=js&"
export * from "./travel-insurance-companies.js?vue&type=script&lang=js&"
import style0 from "./travel-insurance-companies.scss?vue&type=style&index=0&id=ef2c4578&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2c4578",
  null
  
)

export default component.exports